import { render, staticRenderFns } from "./popup-move-snapshot-to-folder.vue?vue&type=template&id=bd71a9d8&scoped=true"
import script from "./popup-move-snapshot-to-folder.vue?vue&type=script&lang=js"
export * from "./popup-move-snapshot-to-folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd71a9d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd71a9d8')) {
      api.createRecord('bd71a9d8', component.options)
    } else {
      api.reload('bd71a9d8', component.options)
    }
    module.hot.accept("./popup-move-snapshot-to-folder.vue?vue&type=template&id=bd71a9d8&scoped=true", function () {
      api.rerender('bd71a9d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mprofiles/views/find-user/popups/popup-move-snapshot-to-folder.vue"
export default component.exports